
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { objAny } from "../../common/common-interface";
import { addQrcodeJs } from "@/common/add-js";
@Component
export default class PiQrcodeShow extends Vue {
  @Prop({ default: "" }) private url!: string;
  @Prop({ default: 200 }) private width!: number;
  @Prop({ default: 200 }) private height!: number;
  @Prop({ default: false }) private isShowUrl!: boolean;

  @Watch("url")
  getVisible(val: string, old: string) {
    if (val != old) {
      this.init();
    }
  }

  private win: objAny = window;
  private qrcodeObj: objAny = {};
  private isInit = false;

  async init(): Promise<void> {
    await addQrcodeJs();
    this.qrcodeShow();
  }
  public qrcodeShow(): void {
    if (!this.win.QRCode) {
      setTimeout(() => {
        this.qrcodeShow();
      }, 200);
    } else {
      if (this.url != "") {
        this.$nextTick(() => {
          const divObj: objAny = this.$refs["qrcodeDiv"];
          if (!this.isInit) {
            divObj.innerHTML = "";
            this.isInit = true;
            this.qrcodeObj = new this.win.QRCode(divObj, {
              width: 200,
              height: 200
            });
          }
          this.qrcodeObj.makeCode(this.url);
        });
      }
    }
  }
  mounted() {
    this.init();
  }
}
